import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import { config, library } from '@fortawesome/fontawesome-svg-core'

config.autoAddCss = false

import {
  faA,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAlignSlash,
  faArrowDown,
  faAsterisk,
  faArrowDownToBracket,
  faArrowDownToLine,
  faArrowDownToSquare,
  faArrowUpToBracket,
  faArrowUpToLine,
  faArrowLeft,
  faArrowLeftFromLine,
  faArrowLeftLong,
  faArrowPointer,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightFromLine,
  faArrowRightLong,
  faArrowsMaximize,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowUpRight,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowUpRightFromSquare,
  faB,
  faBars,
  faBell,
  faBook,
  faBookBookmark,
  faBookmark,
  faBookFont,
  faBookOpen,
  faBorderBottom,
  faBorderLeft,
  faBorderRight,
  faBorderTop,
  faBriefcase,
  faBringForward,
  faBringFront,
  faBullhorn,
  faCameraViewfinder,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleInfo,
  faCircleNotch,
  faCirclePause,
  faCirclePlay,
  faCircleQuestion,
  faCity,
  faClock,
  faClockRotateLeft,
  faCloud,
  faCloudArrowUp,
  faCloudCheck,
  faCloudSlash,
  faCode,
  faCog,
  faCoins,
  faCommand,
  faCommentLines,
  faComputerMouseScrollwheel,
  faCopy,
  faCreditCard,
  faCube,
  faDownload,
  faEllipsis,
  faEllipsisVertical,
  faEnvelope,
  faExclamation,
  faExclamationCircle,
  faExpand,
  faEye,
  faFile,
  faFileAudio,
  faFileCheck,
  faFileCode,
  faFileExport,
  faFileImage,
  faFileInvoice,
  faFileLines,
  faFileZipper,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFlag,
  faFloppyDisk,
  faFolder,
  faFolderPlus,
  faFont,
  faGear,
  faGlobe,
  faGlobePointer,
  faGraduationCap,
  faGrid2,
  faGripLines,
  faH1,
  faH2,
  faH3,
  faH4,
  faH5,
  faH6,
  faHeadphones,
  faHeart,
  faHighlighter,
  faHistory,
  faHome,
  faHourglassHalf,
  faI,
  faImage,
  faImages,
  faIndent,
  faInfo,
  faInfoCircle,
  faItalic,
  faKeyboard,
  faLaptop,
  faLaptopMobile,
  faLayerGroup,
  faLineColumns,
  faLink,
  faLinkSlash,
  faListCheck,
  faListOl,
  faListTree,
  faListUl,
  faLocationCrosshairs,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMerge,
  faMicrophone,
  faMobile,
  faMobileRotate,
  faNote,
  faObjectGroup,
  faObjectUngroup,
  faObjectsColumn,
  faPageBreak,
  faPaintbrushPencil,
  faPalette,
  faParagraphRtl,
  faPause,
  faPen,
  faPenField,
  faPeopleGroup,
  faPlay,
  faPlus,
  faPresentationScreen,
  faQrcode,
  faQuoteRight,
  faRectangle,
  faRectanglesMixed,
  faRectangleVertical,
  faReflectHorizontal,
  faReflectVertical,
  faRefresh,
  faRemoveFormat,
  faRepeat,
  faRightLeft,
  faRotateLeft,
  faRotateRight,
  faScissors,
  faScroll,
  faSearch,
  faSendBack,
  faSendBackward,
  faShapes,
  faShare,
  faShareNodes,
  faShieldCheck,
  faShoppingBasket,
  faSidebar,
  faSignPost,
  faSparkles,
  faSpellCheck,
  faSquare,
  faStar,
  faStrikethrough,
  faSubtitles,
  faSync,
  faTableLayout,
  faTablePivot,
  faTablet,
  faTabletScreenButton,
  faTags,
  faText,
  faThumbsDown,
  faThumbsUp,
  faTimer,
  faTimes,
  faTimesCircle,
  faToggleOn,
  faTrashCan,
  faUnderline,
  faUndo,
  faUser,
  faUserClock,
  faUserGroup,
  faUserGroupSimple,
  faUserHair,
  faUserHairLong,
  faUserTie,
  faVideo,
  faVolume,
  faVolumeHigh,
  faVolumeLow,
  faVolumeOff,
  faVolumeSlash,
  faWaveSine,
  faTrashCanList,
  faTriangleExclamation,
  faPaperPlane,
  faStop,
  faMinus,
  faWandMagicSparkles,
} from '@fortawesome/pro-light-svg-icons'

import {
  faArrowLeft as fsArrowLeft,
  faArrowRight as fsArrowRight,
  faBell as fsBell,
  faBolt as fsBolt,
  faBriefcase as fsBriefcase,
  faCheck as fsCheck,
  faCircle as fsCircle,
  faCircleCheck as fsCircleCheck,
  faCircleExclamation as fsCircleExclamation,
  faCircleInfo as fsCircleInfo,
  faCircleNotch as fsCircleNotch,
  faCirclePlay as fsCirclePlay,
  faCrown as fsCrown,
  faGift as fsGift,
  faHeadphones as fsHeadphones,
  faHeart as fsHeart,
  faHistory as fsHistory,
  faLock as fsLock,
  faMicrophone as fsMicrophone,
  faPaperPlane as fsPaperPlane,
  faPause as fsPause,
  faPen as fsPen,
  faPlay as fsPlay,
  faStar as fsStar,
  faStop as fsStop,
  faTimes as fsTimes,
  faTrashCan as fsTrashCan,
} from '@fortawesome/pro-solid-svg-icons'

import {
  faYoutube as fbYoutube,
  faSquareFacebook as fbSquareFacebook,
  faXTwitter as fbXTwitter,
  faLinkedin as fbLinkedin,
} from '@fortawesome/free-brands-svg-icons'

library.add(
  faA,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAlignSlash,
  faArrowDown,
  faAsterisk,
  faArrowDownToBracket,
  faArrowDownToLine,
  faArrowDownToSquare,
  faArrowUpToBracket,
  faArrowUpToLine,
  faArrowLeft,
  faArrowLeftFromLine,
  faArrowLeftLong,
  faArrowPointer,
  faArrowRight,
  faArrowRightFromBracket,
  faArrowRightFromLine,
  faArrowRightLong,
  faArrowsMaximize,
  faArrowsUpDownLeftRight,
  faArrowUp,
  faArrowUpFromBracket,
  faArrowUpRight,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowUpRightFromSquare,
  faB,
  faBars,
  faBell,
  faBook,
  faBookBookmark,
  faBookmark,
  faBookFont,
  faBookOpen,
  faBorderBottom,
  faBorderLeft,
  faBorderRight,
  faBorderTop,
  faBriefcase,
  faBringForward,
  faBringFront,
  faBullhorn,
  faCameraViewfinder,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCircleInfo,
  faCircleNotch,
  faCirclePause,
  faCirclePlay,
  faCircleQuestion,
  faCity,
  faClock,
  faClockRotateLeft,
  faCloud,
  faCloudArrowUp,
  faCloudCheck,
  faCloudSlash,
  faCode,
  faCog,
  faCoins,
  faCommand,
  faCommentLines,
  faComputerMouseScrollwheel,
  faCopy,
  faCreditCard,
  faCube,
  faDownload,
  faEllipsis,
  faEllipsisVertical,
  faExclamation,
  faExclamationCircle,
  faExpand,
  faEye,
  faEnvelope,
  faFile,
  faFileAudio,
  faFileCheck,
  faFileCode,
  faFileExport,
  faFileImage,
  faFileInvoice,
  faFileLines,
  faFileZipper,
  faFilePdf,
  faFilePowerpoint,
  faFileWord,
  faFlag,
  faFloppyDisk,
  faFolder,
  faFolderPlus,
  faFont,
  faGear,
  faGlobe,
  faGlobePointer,
  faGraduationCap,
  faGrid2,
  faGripLines,
  faH1,
  faH2,
  faH3,
  faH4,
  faH5,
  faH6,
  faHeadphones,
  faHeart,
  faHighlighter,
  faHistory,
  faHome,
  faHourglassHalf,
  faI,
  faImage,
  faImages,
  faIndent,
  faInfo,
  faInfoCircle,
  faItalic,
  faKeyboard,
  faLaptop,
  faLaptopMobile,
  faLayerGroup,
  faLineColumns,
  faLink,
  faLinkSlash,
  faListCheck,
  faListOl,
  faListTree,
  faListUl,
  faLocationCrosshairs,
  faLock,
  faMagnifyingGlass,
  faMagnifyingGlassMinus,
  faMagnifyingGlassPlus,
  faMerge,
  faMicrophone,
  faMinus,
  faMobile,
  faMobileRotate,
  faNote,
  faObjectGroup,
  faObjectUngroup,
  faObjectsColumn,
  faPageBreak,
  faPaintbrushPencil,
  faPalette,
  faPaperPlane,
  faParagraphRtl,
  faPause,
  faPen,
  faPenField,
  faPeopleGroup,
  faPlay,
  faPlus,
  faPresentationScreen,
  faQrcode,
  faQuoteRight,
  faRectangle,
  faRectanglesMixed,
  faRectangleVertical,
  faReflectHorizontal,
  faReflectVertical,
  faRefresh,
  faRemoveFormat,
  faRepeat,
  faRightLeft,
  faRotateLeft,
  faRotateRight,
  faScissors,
  faScroll,
  faSearch,
  faSendBack,
  faSendBackward,
  faShapes,
  faShare,
  faShareNodes,
  faShieldCheck,
  faShoppingBasket,
  faSidebar,
  faSignPost,
  faSparkles,
  faSpellCheck,
  faSquare,
  faStar,
  faStop,
  faStrikethrough,
  faSubtitles,
  faSync,
  faTableLayout,
  faTablePivot,
  faTablet,
  faTabletScreenButton,
  faTags,
  faText,
  faThumbsDown,
  faThumbsUp,
  faTimer,
  faTimes,
  faTimesCircle,
  faToggleOn,
  faTrashCan,
  faTrashCanList,
  faTriangleExclamation,
  faUnderline,
  faUndo,
  faUser,
  faUserClock,
  faUserGroup,
  faUserGroupSimple,
  faUserHair,
  faUserHairLong,
  faUserTie,
  faVideo,
  faVolume,
  faVolumeHigh,
  faVolumeOff,
  faVolumeLow,
  faVolumeSlash,
  faWaveSine,
  fbSquareFacebook,
  fbLinkedin,
  fbXTwitter,
  fbYoutube,
  fsArrowLeft,
  fsArrowRight,
  fsBell,
  fsBolt,
  fsBriefcase,
  fsCheck,
  fsCircle,
  fsCircleCheck,
  fsCircleExclamation,
  fsCircleInfo,
  fsCircleNotch,
  fsCirclePlay,
  fsCrown,
  fsGift,
  fsHeadphones,
  fsHeart,
  fsHistory,
  fsLock,
  fsMicrophone,
  fsPaperPlane,
  fsPause,
  fsPen,
  fsPlay,
  fsStar,
  fsStop,
  fsTimes,
  fsTrashCan,
  faWandMagicSparkles,
)

export { FontAwesomeIcon, FontAwesomeLayers }
